import { render, staticRenderFns } from "./LastSaved.vue?vue&type=template&id=04939f8e&scoped=true&"
import script from "./LastSaved.vue?vue&type=script&lang=js&"
export * from "./LastSaved.vue?vue&type=script&lang=js&"
import style0 from "./LastSaved.vue?vue&type=style&index=0&id=04939f8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04939f8e",
  null
  
)

export default component.exports